import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    offers: [],
    loading: false,
    offerSearch:'',
    offerDetails: {},
    offerEdit: false,
    offerModal: false,
};


const orderReducer = createSlice({
    name: "offerReducer",
    initialState: initialState,
    reducers: {
        updateOffers: (state, { type, payload }) => {
            state.offers = payload
        },
        updateOfferLoading: (state, { type, payload }) => {
            state.loading = payload
        },
        updateOfferSearch: (state, { type, payload }) => {
            state.offerSearch = payload
        },
        updateOfferDetail: (state, { type, payload }) => {
            state.offerDetails = payload
        },
        updateOfferEdit: (state, { type, payload }) => {
            state.offerEdit = payload
        },
        updateOfferModal: (state, { type, payload }) => {
            state.offerModal = payload
        },
    }
})

export const { updateOffers, updateOfferLoading, updateOfferSearch, updateOfferDetail, updateOfferEdit ,updateOfferModal } = orderReducer.actions



export default orderReducer.reducer;